import * as actionTypes from "./actionTypes";
import * as eventTypes from "./eventTypes";
import initialState from "reducers/initialState";
import * as types from "actions/actionTypes";

const folderSidebarReducer = (state = initialState.currentFolder.sidebarData, action) => {
  switch (action.type) {
    case actionTypes.LOAD_FOLDER_SUMMARY_SUCCEEDED: {
      return {
        ...state,
        summary: action.payload.folderSummary
      };
    }

    case eventTypes.FOLDER_SUMMARY_CHANGED: {
      return {
        ...state,
        summary: initialState.currentFolder.sidebarData.summary
      };
    }
    case types.SIDEBAR_DRAWER_SELECTED: {
      return {
        ...state,
        sidebarDrawer: action.payload
      };
    }

    default:
      return state;
  }
};

export default folderSidebarReducer;
